import clsx from "clsx";
import "./Card.css";
import type React from "react";

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  /** `flush` has no padding or gap, for content that runs to the card's edges. */
  variant?: "default" | "flush";
  /**
   * `md` (the default) grows with the viewport, for cards on a page. `sm` is a dense card inside a
   * panel, dialog or list, with a tighter gap between its children.
   */
  padding?: "sm" | "md";
  /**
   * `inset` sits inside another surface (a subtle fill, no shadow). `primary` is tinted with the
   * primary colour: something the user is acting on, or a message from CalmLens.
   */
  tone?: "default" | "inset" | "primary";
}

const Card = (props: CardProps) => {
  const {
    children,
    className,
    variant = "default",
    padding = "md",
    tone = "default",
    ...otherProps
  } = props;

  return (
    <div
      className={clsx(
        "calmlens-card",
        variant === "flush" ? "calmlens-card-flush" : "calmlens-card-default",
        className,
      )}
      data-padding={padding === "md" ? undefined : padding}
      data-tone={tone === "default" ? undefined : tone}
      {...otherProps}
    >
      {children}
    </div>
  );
};

export default Card;
